import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.swiper-button-next`,
            prevEl: `.swiper-button-prev`,
        },

        // Pagination (bullet)
        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}

// Slider Events
let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

let eventsConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        // loop : true,
        slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },
    
    breakpoints: {
        1201: {
            slidesPerView: 4,
            spaceBetween: 30
        },

        961: {
            slidesPerView: 4,
            spaceBetween: 20
        },
        
        641: {
            slidesPerView: 2,
            spaceBetween: 20
        },

        0: {
            slidesPerView: 1,
            spaceBetween: 30
        }
    },    

    navigation: {
        nextEl: `.home-events__navigation .swiper-button-next`,
        prevEl: `.home-events__navigation .swiper-button-prev`,
    }
}

if(eventsSlides >= 1) {
    let swiperEvents = new Swiper('.home-events .swiper-container', eventsConfig);
}


/*** Kiosque Image ***/
const kiosqueImageSlideshow = document.querySelector('.kiosque .swiper-container__image') !== null;
        
if (kiosqueImageSlideshow) {
    let kiosqueImageSlides = document.querySelectorAll('.kiosque .swiper-container__image .swiper-slide').length;

    let kiosqueImageConfig = {
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,

        coverflowEffect: {
            rotate: 0,
            slideShadows: false,
        },

        grabCursor: false,

        allowTouchMove: false,

        keyboard: {
            enabled: true,
        },

        navigation: {
            prevEl: `.kiosque__prev`,
            nextEl: `.kiosque__next`,
        },

        breakpoints: {
            1201: {
                slidesPerView: 1,
                spaceBetween: 0
            },

            961: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            
            641: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        }
    }

    let swiperKiosqueImage = new Swiper('.kiosque .swiper-container__image', kiosqueImageConfig);
}

/*** Kiosque Content ***/
const kiosqueContentSlideshow = document.querySelector('.kiosque .swiper-container__content') !== null;
        
if (kiosqueContentSlideshow) {
    let kiosqueContentSlides = document.querySelectorAll('.kiosque .swiper-container__content .swiper-slide').length;

    let kiosqueContentConfig = {
        effect: 'fade',
        loop: true,
        centeredSlides: true,
        allowTouchMove: false,

        keyboard: {
            enabled: true,
        },

        grabCursor: false,

        navigation: {
            prevEl: `.kiosque__prev`,
            nextEl: `.kiosque__next`,
        },

        breakpoints: {
            1201: {
                slidesPerView: 1,
                spaceBetween: 0
            },

            961: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            
            641: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
    }

    let swiperKiosqueContent = new Swiper('.kiosque .swiper-container__content', kiosqueContentConfig);
}


